import { render, staticRenderFns } from "./TreasureIcon.vue?vue&type=template&id=24c273c6&scoped=true"
import script from "./TreasureIcon.vue?vue&type=script&lang=js"
export * from "./TreasureIcon.vue?vue&type=script&lang=js"
import style0 from "./TreasureIcon.vue?vue&type=style&index=0&id=24c273c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c273c6",
  null
  
)

export default component.exports